function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/web.dom-collections.iterator.js";
import { action } from "mobx";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { getName } from "../../ModelMixins/CatalogMemberMixin";
import { filterSelectableDimensions } from "../../Models/SelectableDimensions/SelectableDimensions";
import { useViewState } from "../Context";
import SelectableDimension from "../SelectableDimensions/SelectableDimension";
import WorkbenchItemControls from "../Workbench/Controls/WorkbenchItemControls";
import { Panel } from "./Panel";
import { PanelMenu } from "./PanelMenu";
import WorkflowPanel from "./WorkflowPanel";

/** Two main components:
 * - Title panel with `title`, item `WorkbenchItemControls` and menu
 * - Panel for each top-level selectable dimension
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SelectableDimensionWorkflow = observer(() => {
  const viewState = useViewState();
  const terria = viewState.terria;
  const [t] = useTranslation();
  return terria.selectableDimensionWorkflow ? /*#__PURE__*/_jsxs(WorkflowPanel, {
    viewState: viewState,
    icon: terria.selectableDimensionWorkflow.icon,
    title: terria.selectableDimensionWorkflow.name,
    closeButtonText: t("compare.done"),
    onClose: action(() => {
      terria.selectableDimensionWorkflow = undefined;
    }),
    footer: terria.selectableDimensionWorkflow.footer,
    children: [/*#__PURE__*/_jsx(Panel, {
      title: getName(terria.selectableDimensionWorkflow.item),
      menuComponent: terria.selectableDimensionWorkflow.menu ? /*#__PURE__*/_jsx(PanelMenu, _objectSpread({}, terria.selectableDimensionWorkflow.menu)) : undefined,
      children: /*#__PURE__*/_jsx(WorkbenchItemControls, {
        item: terria.selectableDimensionWorkflow.item,
        viewState: viewState,
        disableViewingControlsMenu: true,
        controls: {
          disableAll: true,
          opacity: true,
          timer: true,
          dateTime: true,
          shortReport: true
        }
      })
    }), terria.selectableDimensionWorkflow.selectableDimensions.map((groupDim, _i) => {
      var _groupDim$name, _groupDim$name2, _groupDim$isOpen;
      if (groupDim.disable) return null;
      const childDims = filterSelectableDimensions()(groupDim.selectableDimensions);
      if (childDims.length === 0) return null;
      return /*#__PURE__*/_jsx(Panel, {
        title: (_groupDim$name = groupDim.name) !== null && _groupDim$name !== void 0 ? _groupDim$name : groupDim.id,
        isOpen: (_groupDim$isOpen = groupDim.isOpen) !== null && _groupDim$isOpen !== void 0 ? _groupDim$isOpen : true,
        onToggle: groupDim.onToggle,
        collapsible: true,
        children: childDims.map(childDim => {
          var _terria$selectableDim, _terria$selectableDim2;
          return /*#__PURE__*/_jsx(SelectableDimension, {
            id: "".concat((_terria$selectableDim2 = terria.selectableDimensionWorkflow) === null || _terria$selectableDim2 === void 0 ? void 0 : _terria$selectableDim2.item.uniqueId, "-").concat(childDim.id),
            dim: childDim
          }, "".concat((_terria$selectableDim = terria.selectableDimensionWorkflow) === null || _terria$selectableDim === void 0 ? void 0 : _terria$selectableDim.item.uniqueId, "-").concat(childDim.id, "-fragment"));
        })
      }, (_groupDim$name2 = groupDim.name) !== null && _groupDim$name2 !== void 0 ? _groupDim$name2 : groupDim.id);
    })]
  }) : null;
});
export default SelectableDimensionWorkflow;